export function isValidDomain(domain: string): { isValid: boolean; cleanDomain: string } {
  // Remove common prefixes
  let cleanDomain = domain.replace(/^(https?:\/\/)?(www\.)?/, '');
  
  // Remove anything after the first slash to eliminate any subfolders
  cleanDomain = cleanDomain.split('/')[0];
  
  // Also handle backslashes for Windows-style paths (just in case)
  cleanDomain = cleanDomain.split('\\')[0];
  
  // Domain validation regex that accepts any TLD
  const domainRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z-]{2,}$/;
  
  return {
    isValid: domainRegex.test(cleanDomain),
    cleanDomain
  };
}